<script setup lang="ts">
import { MediaItem } from '@/modules/media-library/components/media-library.interface';

const props = defineProps<{
   media: MediaItem[];
   selectedMedia: MediaItem | null;
   showImages?: boolean;
   showVideos?: boolean;
}>();

function isDisabled(item: MediaItem): boolean {
   return !((props.showImages && item.is_image) || (props.showVideos && item.is_video));
}
const emit = defineEmits(['onSelect']);

function handleSelect(id: number) {
   emit('onSelect', id);
}
</script>

<template>
   <section class="image-grid">
      <template v-for="img in props.media" :key="img.id">
         <article
            v-if="img.is_image || img.is_video"
            class="image-item"
            :class="{
               selected: props.selectedMedia && img.id === props.selectedMedia.id,
               disabled: isDisabled(img),
            }"
            @click="handleSelect(img.id)"
         >
            <img v-if="img.is_image" :src="img.url" />
            <video v-else-if="img.is_video" :src="img.url" controls></video>
            <div class="image-item__name">{{ img.name }}</div>
         </article>
      </template>
   </section>
</template>

<style lang="scss" scoped>
.image-grid {
   flex: 0 0 70%;
   display: grid;
   grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
   grid-auto-rows: min-content;
   column-gap: 1rem;
   row-gap: 1rem;
}

.image-item {
   cursor: pointer;
   border-radius: 0.5rem;
   display: flex;
   flex-direction: column;
   aspect-ratio: 3 / 2;

   &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
   }

   img {
      border-radius: 0.5rem;
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
   }

   video {
      border-radius: 0.5rem;
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
   }

   .image-item__name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 1px;
      color: var(--nxt-dark);
      font-size: smaller;
   }
}
</style>
